import { apiCallWrapper } from "traveldesk-ui";
import OfferMiniDisplayModel from "../models/OfferMiniDisplayModel";
export default class OffersApiService {
    public static async getAllMiniDisplay(dispatch: any) {
        return await apiCallWrapper<OfferMiniDisplayModel[]>(`/api/offers/options`, 'GET', dispatch)
    }
}